import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "작성연도",
        value: "year",
        query: { y: "year" },
        options: {
          afterFix: "년",
        },
      },
      {component: 'search-disaster-types', label: '재해형태', value: 'disaster', query: {'dty': 'disaster'}, options: {}},
      {
        component: 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['작성연도', '재해형태']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      let year = search.year;
      conditions.push({ key: "header.year", operator: "=", value: `${year}` });
    }

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.riskAppraisalList[%].input_3', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "공정명",
        "key": "body.공정명"
      },
      {
        "name": "재해형태",
        "key": "body.riskAppraisalList[%].input_3"
      },
      {
        name: "작성연도",
        key: "header.year",
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: return func.getContent(value).공정명 // 공정명
        case 1: return func.getContentRiskList(func.getContent(value).riskAppraisalList).replace(/직접입력_/g, '') // 재해형태
        case 2: return postContent.header.year; // 작성연도
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  customExcelDownload: async (list, title) => {
    // 공정명,
    const workbook = new ExcelJS.Workbook();
    // sheet 생성
    const worksheet = workbook.addWorksheet("안전보건공단");

    // 컬럼 크기
    for (let i = 1; i <= 16; i++) {
      if (i === 1) {
        worksheet.getColumn(i).width = 4;
      } else if (i === 2) {
        worksheet.getColumn(i).width = 40;
      } else if (i === 5) { //
        worksheet.getColumn(i).width = 20;
      } else {
        worksheet.getColumn(i).width = 17;
      }
    }

    const data = [];
    data.push([
      { value: "No.", style: "borderFillHead" },
      { value: "공정명", style: "borderFillHead" },
      { value: "평가구분", style: "borderFillHead" },
      { value: "유해·위험요인", style: "borderFillHead" },
      { value: "위험 기계·기구·설비", style: "borderFillHead" },
      { value: "재해형태", style: "borderFillHead" },
      { value: "등록(인증)번호", style: "borderFillHead" },
      { value: "등록일", style: "borderFillHead" },
      { value: "만료일", style: "borderFillHead" },
      { value: "작성연도", style: "borderFillHead" },
    ]);

    for (const post of list) {
      const postContent = JSON.parse(post.post_content);
      const header = postContent.header || {};
      const body = postContent.body || {};

      for (const risk of body.riskAppraisalList) {
        data.push([
          { value: data.length, style: "borderHead" },
          { value: body.공정명, style: "borderHead" },
          { value: risk.input_2, style: "borderHead" },
          { value: risk.input_4, style: "borderHead" },
          { value: risk.input_5.includes('직접입력') ? risk.input_5_0 : risk.input_5, style: "borderHead" },
          { value: risk.input_3, style: "borderHead" },
          { value: risk.등록번호, style: "borderHead" },
          { value: risk.등록일, style: "borderHead" },
          { value: risk.만료일, style: "borderHead" },
          { value: header.year, style: "borderHead" },
        ])
      }
    }

    await excelSupporter.addTable(worksheet, {
      rowHeightList: [30, 70.0, 22.4],
      colgroup: ["A:A", "B:B", "C:C", "D:D", "E:E", "F:F", "G:G", "H:H", "I:I", "J:J"],
      data,
    });
    await excelSupporter.workbookDownload(workbook, title);
  }
}
export default list;
